"use client";

import { useState, useEffect } from "react";
import { HiOutlineLink } from "react-icons/hi"; // Matches the chain link icon in the image
import styles from "../css/medications.module.css";

export default function Medications({ patientData = {} }) {
  const [meds, setMeds] = useState([{ name: "", detail: "", date: "" }]); 

  useEffect(() => {
    const raw = patientData.medications;
    if (!raw) {
      setMeds([{ name: "", detail: "", date: "" }]);
      return;
    }
    if (!Array.isArray(raw)) {
      setMeds([{ name: "", detail: "", date: "" }]);
      return;
    }
    const mapped = raw.map((m) => ({
      name: m?.drug || m?.name || "",
      detail: m?.dosage ? `${m.dosage} — ${m.frequency || ""}` : (m?.detail || ""),
      date: m?.startDate ? `Since ${new Date(m.startDate).toISOString().split("T")[0]}` : (m?.date || ""),
    }));
    setMeds(mapped.length ? mapped : [{ name: "", detail: "", date: "" }]);
  }, [patientData.medications]);

  const handleMedsChange = (index, field, value) => {
    const updated = [...meds];
    updated[index][field] = value;
    setMeds(updated);
  };

  const addMeds = () => {
    setMeds([...meds, { name: "", detail: "", date: "" }]);
  };

  const deleteMeds = (index) => {
    if (meds.length === 1) {
      setMeds([{ name: "", detail: "", date: "" }]);
      return;
    }
    setMeds(meds.filter((_, i) => i !== index));
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HiOutlineLink className={styles.linkIcon} />
        <h3 className={styles.title}>Current Medications</h3>
      </div>

      <div className={styles.list}>
        {meds.map((med, index) => (
          <div key={index} className={styles.row}>
            <div className={styles.medCard}>
              <div className={styles.medMainInfo}>
                <input
                  type="text"
                  className={styles.nameInput}
                  value={med.name}
                  onChange={(e) => handleMedsChange(index, "name", e.target.value)}
                  placeholder="Medication name"
                />
                <input
                  type="text"
                  className={styles.detailInput}
                  value={med.detail}
                  onChange={(e) => handleMedsChange(index, "detail", e.target.value)}
                  placeholder="Dosage — Frequency"
                />
              </div>
              <div className={styles.dateInfo}>
                <span>{med.date}</span>
              </div>
            </div>
            
            <button className={styles.deleteBtn} onClick={() => deleteMeds(index)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
            </button>
          </div>
        ))}
      </div>

      <button className={styles.addBtn} onClick={addMeds}>+</button>
    </div>
  );
}